import React, { FC } from 'react';

import '@ant-design/compatible/assets/index.css';
import { Modal, Form, Input, Row, Button } from 'antd';
import { connect } from 'react-redux';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { withRouter } from 'react-router';

const FormItem = Form.Item;

const SelfManagedSupplierInvitationForm: FC<any> = ({
	supplierFacility = {},
	visible,
	onCancel,
	onSkip,
	onSubmit,
	loading,
	showContext = false,
}): React.ReactElement => {
	const [form] = Form.useForm();

	const dismissHandler = onSkip || onCancel;

	const footer = [
		onSkip ? (
			<Button key="skip" onClick={onSkip} disabled={loading}>
				Skip for now
			</Button>
		) : onCancel ? (
			<Button key="cancel" onClick={onCancel} disabled={loading}>
				Cancel
			</Button>
		) : null,
		<Button key="invite" type="primary" loading={loading} onClick={() => form.submit()}>
			Invite Supplier
		</Button>,
	].filter(Boolean);

	const supplierDisplayName = nullSafeGetOrElse('displayName', supplierFacility, '');
	const titleText = supplierDisplayName
		? `Invite ${supplierDisplayName} to OpenWrench`
		: 'Invite supplier to OpenWrench';

	const titleNode = (
		<div>
			<div>{titleText}</div>
			{showContext && (
				<div
					className="bodyregular text-character-secondary"
					style={{ marginTop: 8, fontWeight: 400 }}
				>
					{supplierDisplayName ? `${supplierDisplayName} is` : 'This supplier is'} currently
					self-managed and hasn't been invited to OpenWrench. Add their contact details to send an
					invite now.
				</div>
			)}
		</div>
	);

	return (
		<Modal
			visible={visible}
			width={600}
			title={titleNode}
			onCancel={dismissHandler}
			footer={footer}
			confirmLoading={loading}
		>
			<Form
				form={form}
				layout="vertical"
				className="supplierForm"
				initialValues={{
					primaryContactEmail: nullSafeGetOrElse('primaryContactEmail', supplierFacility, ''),
					primaryContactFirstName: nullSafeGetOrElse(
						'primaryContactFirstName',
						supplierFacility,
						''
					),
					primaryContactLastName: nullSafeGetOrElse('primaryContactLastName', supplierFacility, ''),
				}}
				onFinish={onSubmit}
			>
				<FormItem
					label="Supplier Contact Email Address"
					name="primaryContactEmail"
					rules={[
						{ required: true, message: "Please input your primary contact's email!" },
						{ type: 'email', message: 'This is not a valid email!' },
					]}
				>
					<Input placeholder="John.Doe@doeplumbing.com" />
				</FormItem>
				<Row style={{ flexWrap: 'nowrap', gap: '10px' }}>
					<FormItem
						label="Contact First Name"
						name="primaryContactFirstName"
						rules={[{ required: true, message: "Please input your primary contact's first name!" }]}
					>
						<Input placeholder="John" />
					</FormItem>
					<FormItem
						label="Contact Last Name"
						name="primaryContactLastName"
						rules={[{ required: true, message: "Please input your primary contact's last name!" }]}
					>
						<Input placeholder="Doe" />
					</FormItem>
				</Row>
			</Form>
		</Modal>
	);
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps)(SelfManagedSupplierInvitationForm)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
